import {Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {LoggingService} from '../logging.service';
import {SkillModel} from '../skills/skill.model';

import { map } from 'rxjs/operators';
import {Observable, pipe, throwError} from 'rxjs';
import {PodcastModel} from '../podcasts/podcast.model';
import {LichessPlayeridModel} from '../chess/model/lichess.playerid.model';
import {AwardsModel} from '../awards/awards.model';
import {AboutModel} from '../about/about.model';
import {TextModel} from '../text-analytics/text.model';
import {LichessGameModel} from '../chess/model/lichess.game.model';
import {LichessOpeningModel} from '../chess/model/lichess.opening.model';
import {LichessRequestModel} from '../chess/model/lichess.request.model';
import {ResultModel} from '../text-analytics/result.model';


@Injectable()
export class DataService {

  constructor (private httpClient: HttpClient, private loggingService: LoggingService) {}


  /*
  firebase doesn't need indexing such as podcasts["podcasts"] but local JSONs need such as awards["awards"]
   */
  getPodcasts() {
    return this.httpClient.get<PodcastModel[]>('https://ozansenturk.firebaseio.com/podcasts.json', {
      observe: 'body',
      responseType: 'json'
    })
      .pipe(
        map(
          // catchError(this.handleError)
          (podcasts: PodcastModel[]) => {

            // console.log('podcasts 0 ' + podcasts)

            podcasts.sort((a, b) => {



              if ( b.date > a.date) {
                return 1;
              }
              if ( b.date < a.date) {
                return -1;
              }

              return 0;
            });

            return podcasts;
          })

      );
  }


  getChessPlayers() {
    return this.httpClient.get<LichessPlayeridModel[]>('https://ozansenturk.firebaseio.com/chess-players.json', {
      observe: 'body',
      responseType: 'json'
    });

  }

  getAwards() {
    return this.httpClient.get<AwardsModel[]>('assets/data/awards.json', {
      observe: 'body',
      responseType: 'json'
    })
      .pipe(
        map(
          // catchError(this.handleError)
          (awards: AwardsModel[]) => {

            awards['awards'].sort((a, b) => {

              if ( b.date > a.date) {
                return 1;
              }
              if ( b.date < a.date) {
                return -1;
              }

              return 0;
            });

            return awards['awards'];
          })

      );
  }

  getAbout(){
    return this.httpClient.get<AboutModel>('assets/data/about.json', {
      observe: 'body',
      responseType: 'json'
    })
      .pipe(
        map(
          // catchError(this.handleError)
          (about: AboutModel) => {

            return about['about'];

          })
      );
  }
  // headers: new HttpHeaders({'accept': 'application/json'})
  textFeatureExtract(textRequest: TextModel) {
    // Send Http request

    console.log('text request: ' + textRequest);

    let targetUrl = 'https://analyticai.co.uk/nlp/v1/lemmatize';

    //TODO refactor with enums
    if (textRequest.feature === 'nouns') {
      targetUrl = 'https://analyticai.co.uk/nlp/v1/nouns';
    } else if (textRequest.feature === 'entities') {
      targetUrl = 'https://analyticai.co.uk/nlp/v1/entities';
    }

    return this.httpClient
      .post(
        targetUrl,
        textRequest
      )
      .pipe(
        map(
          // catchError(this.handleError)
          (responseData: { 'result': string}) => {

            let nounMap: Map<string, string[]> = new Map<string, string[]>();

            const responseResult = responseData['result'];

            if (textRequest.feature === 'nouns') {

              nounMap = this.fillResultMapByFeatureElement(responseResult);

            } else if (textRequest.feature === 'lemmatize') {
              nounMap.set('lemmatize', [responseData['result']]);
            } else if (textRequest.feature === 'entities') {
              nounMap = this.fillResultMapByFeatureElement(responseResult);
            }

            const result: ResultModel = new ResultModel(nounMap);
            return result;

          })
      );
  }

  private fillResultMapByFeatureElement(responseResult: string) {

    const nounMap: Map<string, string[]> = new Map<string, string[]>();

    for (const nounList of responseResult) {
      if (nounMap.has(nounList[1])) {

        if (nounMap.get(nounList[1]).indexOf(nounList[0]) === -1){
          nounMap.get(nounList[1]).push(nounList[0]);
        } else{
          console.log(nounList[0]);
        }

      } else {
        const tempList: string[] = [];
        tempList.push(nounList[0]);
        nounMap.set(nounList[1], tempList);
      }

    }

    return nounMap;
  }


  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
    }
}
